import { isFailure, SettingsServiceErrorCode } from "@sportal/api";

import {
  LOAD_SETTINGS,
  GET_SETTINGS_SUCCESS,
  GET_SETTINGS_FAILURE,
  SettingsActionTypes,
  SettingsFailurePayload,
  SettingsSuccessPayload,
} from "./settings.types";
import { SBThunkAction } from "../redux.types";
import { getUserMode } from "../info/info.selectors";

const errorMessages = {
  [SettingsServiceErrorCode.MISCONFIGURED]: "app_improperly_configured",
};

export const getSettings =
  (): SBThunkAction<void, SettingsActionTypes> =>
  async (dispatch, getState, { api }) => {
    const userMode = getUserMode(getState());

    dispatch({ type: LOAD_SETTINGS });

    const result = await api.ssm.settings(userMode).get();

    if (isFailure(result)) {
      const message = errorMessages[result.error.code];

      dispatch(getSettingsFailure(result.error));

      return Promise.reject({ ...result.error, text: message });
    } else {
      const { services, reporting } = result.data;

      dispatch(getSettingsSuccess({ services, reporting }));
    }
  };

export const getSettingsSuccess = (
  settings: SettingsSuccessPayload
): SettingsActionTypes => ({
  type: GET_SETTINGS_SUCCESS,
  payload: settings,
});

export const getSettingsFailure = (
  error: SettingsFailurePayload
): SettingsActionTypes => ({
  type: GET_SETTINGS_FAILURE,
  payload: error,
});
